module.exports = __webpack_public_path__ + "static/media/static2.dd117bd2.svg";